import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase";

export const storageService = {
    uploadFile: async (path, file) => {
        const storageRef = ref(storage, path);
        const snapshot = await uploadBytes(storageRef, file);
        return snapshot;
    },

    getDownloadURL: async (path) => {
        const storageRef = ref(storage, path);
        const url = await getDownloadURL(storageRef);
        return url;
    }
};